module.exports = __webpack_public_path__ + "img/zhanxingshi.785acf63.png";